import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Input, Form, Select, message } from 'antd';
import { scoutChatCenterServerUrl } from '../autoConfig';

const AddTeam = ({ onConsultantAdd }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [allOptions, setAllOptions] = useState([]);
  const [debtorOptions, setDebtorOptions] = useState([]);

  const onFinish = async (values) => {
    // Trim whitespace from teamName and teamEmail
    const cleanedValues = {
      ...values,
      teamName: values.teamName.trim(),
      teamEmail: values.teamEmail.trim()
    };

    try {
      const response = await axios({
        method: 'post',
        url: `${scoutChatCenterServerUrl}/team/addTeam`,
        data: {
          ...cleanedValues
        }
      });
      if (response) {
        window.location.reload();
      }
      return response;
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: 'error',
        content: error.response?.data.message
      });
      return [];
    }
  };

  const validateTeamName = (rule, value) => {
    if (allOptions.some((team) => team.teamName === value.trim())) {
      return Promise.reject('This team name is already taken!');
    }
    return Promise.resolve();
  };

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await axios({
          method: 'get',
          url: `${scoutChatCenterServerUrl}/team/getTeams`
        });
        setAllOptions(response.data.teams);
        return response;
      } catch (error) {
        messageApi.open({
          type: 'error',
          content: error.message
        });
        return [];
      }
    };

    const fetchDebtorIds = async () => {
      try {
        const response = await axios({
          method: 'get',
          url: `${scoutChatCenterServerUrl}/debtor/getAllDebtors`
        });
        setDebtorOptions(
          response.data.debtors.map((debtorId) => ({
            label: debtorId,
            value: debtorId
          }))
        );
      } catch (error) {
        messageApi.open({
          type: 'error',
          content: 'Failed to fetch debtor IDs!'
        });
      }
    };

    fetchTeams();
    fetchDebtorIds();
  }, []);

  return (
    <div>
      <Form
        layout={{
          labelCol: {
            span: 4
          },
          wrapperCol: {
            span: 14
          }
        }}
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          name="teamName"
          label="Team Name"
          rules={[
            {
              required: true,
              message: 'Please input your teamName!'
            },
            {
              validator: validateTeamName
            }
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          name="teamEmail"
          label="Team Email"
          rules={[
            {
              required: true,
              message: 'Please input your team email!'
            }
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          name="teamAdmins"
          label="Team Admin Email"
          rules={[
            {
              required: true,
              message: 'Please input your teamAdmin!'
            }
          ]}
        >
          <Select
            mode="tags"
            tokenSeparators={[',']}
            style={{
              width: '100%'
            }}
            placeholder="Please select"
          />
        </Form.Item>
        <Form.Item
          name="teamCoverage"
          label="DebtorId"
          rules={[
            {
              required: true,
              message: 'Please input your teamCoverage!'
            }
          ]}
        >
          <Select
            mode="tags"
            style={{
              width: '100%'
            }}
            placeholder="Please select"
            options={debtorOptions}
          />
        </Form.Item>
        <Form.Item className="flex justify-center">
          <Button htmlType="submit">Submit</Button>
        </Form.Item>
      </Form>
      {contextHolder}
    </div>
  );
};

export default AddTeam;
